var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choosepage{width:100%;height:100%;background-image:url(" + escape(require("../../assets/images/choosebg.png")) + ");background-size:100% 100%}.choosepage>div{height:calc(100% - .9rem)}.choosepage .chooseCon{width:100%;height:.8rem;background:#fff;font-size:.24rem;font-family:MicrosoftYaHei;font-weight:400;color:#333;margin-bottom:.1rem;padding:0 .2rem;line-height:.8rem;-webkit-box-sizing:border-box;box-sizing:border-box}.choosepage .chooseCon .condeteil{position:relative}.choosepage .grouppic{display:inline-block;width:.4rem;height:.4rem;background:#1592e4;border-radius:50%;vertical-align:middle;margin-right:.1rem}.choosepage .jtpic{display:inline-block;width:.14rem;height:.26rem;position:absolute;right:0;top:50%;margin-top:-.09rem}.choosepage .botpic{width:100%;height:.9rem}.choosepage .botpic>img{width:.77rem;height:.64rem;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68a33032","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/choose-hospital.vue
// module id = fNfh
// module chunks = 1